import create from "zustand";
const useRooms = create((set) => ({
  rooms: null,
  setRooms: (data) => set({ rooms: data }),
}));

export default useRooms;
